import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { Link } from 'remix'

export function MainMenu() {
  return (
    <Menu>
      <Menu.Button className="px-3">⌘</Menu.Button>
      <Transition
        as={Fragment}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Menu.Items className={"absolute z-20 flex flex-col gap-2 p-3 shadow-xl bg-white w-60 top-8 bottom-0"}>
          <Menu.Item>
            {({ active }) => (
              <Link
                className={`${active && 'bg-blue-500'}`}
                to="/youtube"
              >
                YouTube Videos
              </Link>
            )}
          </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <Link
              className={`${active && 'bg-blue-500'}`}
              to="/tiktok"
            >
              TikTok Sounds
            </Link>
          )}
        </Menu.Item>
        {/* <Menu.Item disabled>
          <span className="opacity-75">Invite a friend (coming soon!)</span>
        </Menu.Item> */}
      </Menu.Items>
      </Transition>
    </Menu>
  )
}